import { useCore } from '@/composables/core'

const hasEcommerceAccess = () => {
  const { store } = useCore()

  return store.getters['business/hasEcommerceEnabled']
}

export const MOBILE_INVENTORY_ROUTES = {
  STORE: 'inventory-mobile.ecommerce',
  ORDERS: 'inventory-mobile.orders',
  ORDER_DETAILS: 'inventory-mobile.orders.details',
  CREATE_SUPPLY: 'inventory-mobile.orders.create',
}

export default {
  path: 'inventory-mobile',
  name: 'inventory-mobile',
  meta: {
    defaultSubroute: {
      name: MOBILE_INVENTORY_ROUTES.STORE,
    },
  },
  beforeEnter: (_, __, next) => {
    if (hasEcommerceAccess()) {
      next()
    } else {
      next({ name: 'forbidden' })
    }
  },
  component: () => import('@/views/business/inventory/index-mobile.vue'),
  children: [
    {
      path: 'ecommerce/:path(.*)?',
      name: MOBILE_INVENTORY_ROUTES.STORE,
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/inventory/ecommerce/store/index.vue'),
    },
    {
      path: 'orders',
      name: MOBILE_INVENTORY_ROUTES.ORDERS,
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/inventory/ecommerce/orders/index.vue'),
    },
    {
      path: 'orders/create',
      name: MOBILE_INVENTORY_ROUTES.CREATE_SUPPLY,
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/inventory/ecommerce/orders/details.vue'),
    },
    {
      path: 'orders/:documentId',
      name: MOBILE_INVENTORY_ROUTES.ORDER_DETAILS,
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/inventory/ecommerce/orders/details.vue'),
    },
  ],
}
